var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-share-code-page"},[(_vm.isRegistered)?_c('ShareCodeContent'):_c('RegisterSharer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }